module.exports = __webpack_public_path__ + "static/media/icon-checked.be2a0a1f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icon-checked.svg
// module id = 2802
// module chunks = 0